import { Stack } from '@mui/material';
import { AgentFile, AgentFileInvalid } from '../aiAgentsConsts';
import {
  CompletedFileListItem,
  InvalidFileListItem,
  ProcessingFileListItem,
  FailedFileListItem,
} from './FileListItems';
import { AgentFileStatus } from '@server/ai';

const FilesList = ({
  files,
  invalidFiles,
  onRemove,
  onRemoveInvalidFile,
}: {
  files: AgentFile[];
  invalidFiles: AgentFileInvalid[];
  onRemove: (fileId: string) => void;
  onRemoveInvalidFile: (fileId: string) => void;
}) => {
  return (
    <Stack>
      {files.map((file) => {
        switch (file.status) {
          case AgentFileStatus.PROCESSING:
            return (
              <ProcessingFileListItem
                key={file.id}
                file={file}
                onRemove={() => onRemove(file.id)}
              />
            );
          case AgentFileStatus.FAILED:
            return (
              <FailedFileListItem key={file.id} file={file} onRemove={() => onRemove(file.id)} />
            );
          case AgentFileStatus.COMPLETED:
          default:
            return (
              <CompletedFileListItem key={file.id} file={file} onRemove={() => onRemove(file.id)} />
            );
        }
      })}
      {invalidFiles.map((file) => (
        <InvalidFileListItem
          key={file.id}
          file={file}
          onRemove={() => onRemoveInvalidFile(file.id)}
        />
      ))}
    </Stack>
  );
};

export default FilesList;
